import React from "react"

import useWindowSize from "hooks/useWindowSize"

import Footer from "./Footer"
import Header from "./Header"

const Layout = ({ children }) => {
    const { heightW } = useWindowSize()

    return (
        <>
            <Header />

            <main
                className=" w-full pt-6 tablet:pt-8 pb-[100px] px-4 overflow-auto"
                style={ { height: heightW - 72 } }
            >
                <div className="max-w-[600px] mx-auto">{ children }</div>
            </main>

            <Footer />
        </>
    )
}

export default Layout
